import React, { useState, useEffect } from 'react';
import { Button as ANTButton, Tooltip, Skeleton, Tabs, Empty, Drawer, notification, Popconfirm, Divider, Modal, Alert, Form, Tag, Table as ANTDTable, Select as ANTDSelect } from 'antd';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { ResetButton, Button } from '../../../components/Atom/Button';
import Input from 'components/Atom/Input';
import { PageHeader } from '../../../components/Atom/PageHeader';
import '../style.css';
import { formatInTimeZone } from 'date-fns-tz';
import { useDispatch, useSelector } from 'react-redux';
import { setStore } from 'app/features/userSlice';
import EditStore from './editStore';
import { useQuery, useQueryClient } from 'react-query';
import { USER_ROLES, TIMEZONES, StoreBlockList } from 'utils/constant';
import { checkUserPermissions } from 'utils/services';
import http from '../../../utils/http';
import AppOnboarding from './appOnboarding';
import { CautionIcon, DeleteIconFilled, EmptyIcon, InfoIcon } from 'assets/icons';
import Select from 'components/Atom/Select';
import { getGateways } from 'api/gateways';
const TabPane = Tabs.TabPane;

export const Store = () => {
  const queryClient = useQueryClient();
  const [isUpdateWebhook, setIsUpdateWebhook] = useState(false);
  const [isUpdateKey, setIsUpdateKey] = useState({ type: '', loading: false });
  const [open, setOpen] = useState(false);
  const [urlModalOpen, setUrlModalOpen] = useState(false);
  const [delkeysModalOpen, setDelkeysModalOpen] = useState(false);
  const [deleteGateway, setDeleteGateway] = useState(false);
  const [apiKeyModalOpen, setApiKeyModalOpen] = useState(false);
  const [hmacModalOpen, setHmacModalOpen] = useState(false);
  const store = useSelector((state) => state.company.store);
  // const [store, setStore] = useState(useSelector((state) => state.company.store));
  const [webhookUrl, setWebhookUrl] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [editEcomerceChannel, setEditEcomerceChannel] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const dispatch = useDispatch();
  const getStore = async () => {
    const res = await http.get(`/stores/${store?._id}`);
    return res?.data?.data;
  };
  const getStoreKeys = async () => {
    try {
      const res = await http.get(`/stores/keys/${store?._id}`);
      return res?.data?.data;
    } catch (err) {
      return null;
    }
  };
  const { data, refetch, isLoading, isFetching } = useQuery('settings', getStore, {
    enabled: false,
    manual: true,
    initialData: store,
  });
  const {
    data: storeKeys,
    refetch: refetchStoreKeys,
    isLoading: isLoadingStoreKeys,
    isFetching: isFetchingKeys,
  } = useQuery('storeKeys', getStoreKeys, {
    enabled: false,
    manual: true,
  });

  useEffect(() => {
    refetch();
    if (store) {
      refetchStoreKeys();
    }
  }, [store]);

  useEffect(() => {
    if (data?.ecommerceChannels?.length > 0 && data?.ecommerceChannels[0]?.clientId) {
      setSelectedType('dev_dashboard');
    } else if (data?.ecommerceChannels?.length > 0 && data?.ecommerceChannels[0]?.accessToken) {
      setSelectedType('legacy');
    }
  }, [data]);
  const generateFirstTimeKeys = async () => {
    try {
      const res = await http.post(`/stores/keys/${data?._id}`);
      queryClient.setQueryData('storeKeys', res?.data?.data);
    } catch (err) {
      notification.error({ message: err?.response?.data?.message || 'SOMETHING WENT WRONG', placement: 'bottomRight' });
    }
  };
  const handleOnStoreChange = (e) => {
    setStore(e);
  };
  const handleUpdateStoreData = (e) => {
    const updatedData = { ...e, isSelected: store?.isSelected };
    queryClient.setQueryData('settings', updatedData);
    dispatch(setStore(updatedData));
    //refetch keys data according to mode if it changed
    if (e?.isStoreModeChanged && storeKeys) {
      refetchStoreKeys();
    }
  };
  const removeWebhook = async () => {
    if (data?.webhookURL) {
      try {
        const res = await http.delete(`/stores/notification/webhook/url/${data?._id}`);
        notification.success({ message: 'Existing Webhook URL Removed Successfully.', placement: 'bottomRight' });
        setWebhookUrl('');
        handleUpdateStoreData(res?.data?.data);
        setUrlModalOpen(false);
      } catch (err) {
        console.log(err);
        notification.error({ message: err?.response?.data?.message || 'Failed to remove existing webhook', placement: 'bottomRight' });
      }
    } else {
      notification.error({ message: 'Webhook not found', placement: 'bottomRight' });
    }
  };
  const handleEditDetails = () => {
    setOpen(!open);
  };
  const handleEditWebhookDetails = (e) => {
    setIsUpdateWebhook(!isUpdateWebhook);
    if (e === 'cancel') {
      setWebhookUrl('');
    }
  };
  const handleEditDetailsData = async () => {
    if (webhookUrl) {
      setDeleteGateway(true);
      try {
        const payload = {
          webhookURL: String(webhookUrl),
        };
        const res = await http.put(`/stores/notification/webhook/url/${data?._id}`, payload);
        handleUpdateStoreData(res?.data?.data);
        notification.success({ message: 'WEBHOOK URL Updated Successfully.', placement: 'bottomRight' });
      } catch (err) {
        console.log(err.response);
        notification.error({ message: err?.response?.data?.message || 'DATA NOT UPDATE', placement: 'bottomRight' });
      }
      setIsUpdateWebhook(!isUpdateWebhook);
      setDeleteGateway(false);
    } else {
      notification.error({ message: 'Please enter webhook url', placement: 'bottomRight' });
    }
  };
  const storeData = [
    {
      title: 'Store Mode',
      value: data?.activated ? 'Live Mode' : 'Test Mode',
    },
    {
      title: 'Name',
      value: data?.name,
    },
    {
      title: 'Store Id',
      value: data?._id,
    },
    {
      title: 'Email',
      value: data?.email_id || '-',
    },
    {
      title: 'Date of Joining',
      value: data?.createdAt ? formatInTimeZone(data?.createdAt, data?.settings?.timezone || TIMEZONES.PKT, 'MMM d, yyyy h:mm:ss a') : '-',
    },
    {
      title: 'Last Update Time',
      value: data?.updatedAt ? formatInTimeZone(data?.updatedAt, data?.settings?.timezone || TIMEZONES.PKT, 'MMM d, yyyy h:mm:ss a') : '-',
    },
    {
      title: 'Country',
      value: data?.currency?.country || 'Not Set',
    },
    {
      title: 'Timezone',
      value: data?.settings?.timezone || TIMEZONES.PKT,
    },
    {
      title: 'Checkout Brand Logo',
      value: data?.image || 'XStak Logo',
    },
    {
      title: 'Powered By Logo',
      value: data?.poweredByLogo === 'hbl' ? 'HBL Logo' : 'XStak Logo',
    },
    {
      title: 'Meta Pixel Id',
      value: data?.settings?.meta_pixel_id || 'Not Set',
    },
    {
      title: 'Expiry Duration',
      value: `${data?.expiry} (Minutes)`,
    },
    {
      title: 'Custom Payment Expiry Duration',
      value: `${data?.custom_expiry} (Minutes)`,
    },
    {
      title: 'Bin Discount',
      value: data?.settings?.bin_discount ? 'Enabled' : 'Disabled',
    },
    {
      title: 'Fraud Rules',
      value: data?.settings?.fraud_rules ? 'Enabled' : 'Disabled',
    },
    {
      title: 'Block Fraudulent User',
      value: data?.settings?.block_fraud_user ? 'Enabled' : 'Disabled',
    },
    {
      title: 'Block List Fields',
      value: data?.settings?.block_fraud_user && data?.settings?.block_list_fields ? data?.settings?.block_list_fields.map((key) => StoreBlockList[key]).join(', ') : 'Not Set',
    },
    {
      title: 'Store Background Color',
      value: data?.settings?.backdrop?.color?.background ? data?.settings?.backdrop?.color?.background : '#1f2937',
    },
    {
      title: 'Store Forground Color',
      value: data?.settings?.backdrop?.color?.text ? data?.settings?.backdrop?.color?.text : '#FFFFFF',
    },
    // {
    //   title: '1-Tap Payments',
    //   value: data?.settings?.one_tap_payments ? 'Enabled' : 'Disabled',
    // },
    {
      title: 'Reporting Currency',
      value: data?.settings?.currency ? data?.settings?.currency : 'PKR',
    },
    {
      title: 'AMEX Card',
      value: data?.isAmexCardAllowed ? 'Enabled' : 'Disabled',
    },
    {
      title: 'PayPak Card',
      value: data?.isPayPakCardAllowed ? 'Enabled' : 'Disabled',
    },
    {
      title: 'Google Pay',
      value: data?.isGPayAllowed ? 'Enabled' : 'Disabled',
    },
    {
      title: 'Google Merchant Id',
      value: data?.googleMerchantId || 'Not Set',
    },
    // {
    //   title: 'Store Button Color',
    //   value: store?.settings?.button?.color?.background ? store?.settings?.button?.color?.background : 'Display Default Color',
    // },
    // {
    //   title: 'Order Create Email',
    //   value: store?.settings?.order_create_email ? 'Enabled' : 'Disabled',
    // },
    // {
    //   title: 'Order Paid Email',
    //   value: store?.settings?.order_paid_email ? 'Enabled' : 'Disabled',
    // },
  ];
  const ecommerceChannelData = (data) => {
    return [
      {
        title: 'App Type',
        value: data?.type || '-',
      },
      {
        title: 'Domain',
        value: data?.domain || '-',
      },
      ...(data?.type === 'shopify'
        ? [
            {
              title: 'Access Token',
              value: data?.accessToken
                ? [...Array(data?.accessToken?.length)].map((e, i) => (
                    <span className='text-lg' key={i}>
                      &#x2022;
                    </span>
                  ))
                : 'Not Set',
            },
            {
              title: 'Storefront Token',
              value: data?.storefrontToken
                ? [...Array(data?.storefrontToken?.length)].map((e, i) => (
                    <span className='text-lg' key={i}>
                      &#x2022;
                    </span>
                  ))
                : 'Not Set',
            },
            {
              title: 'Secret Key',
              value: data?.secretKey
                ? [...Array(data?.secretKey?.length)].map((e, i) => (
                    <span className='text-lg' key={i}>
                      &#x2022;
                    </span>
                  ))
                : 'Not Set',
            },
          ]
        : []),
    ];
  };

  let values;
  if (data?.ecommerceChannels) {
    values = {
      channelType: data?.ecommerceChannels[0]?.customApp,
      accessToken: data?.ecommerceChannels[0]?.accessToken,
      clientId: data?.ecommerceChannels[0]?.clientId,
      clientSecret: data?.ecommerceChannels[0]?.clientSecret,
    };
  }

  const onFinish = async (value) => {
    try {
      const type = value?.channelType?.value;

      const payload =
        type === 'legacy'
          ? {
              channelType: type,
              access_token: value?.accessToken,
            }
          : type === 'dev_dashboard'
            ? {
                channelType: type,
                client_id: value?.clientId,
                client_secret: value?.clientSecret,
              }
            : null;

      await http.put(`/stores/shopify/creds/${data?._id}`, payload);
      notification.success({ message: 'UPDATED SHOPIFY CUSTOM APP CREDENTIALS.', placement: 'bottomRight' });
    } catch (err) {
      console.log(err.response);
      notification.error({ message: err?.response?.data?.message || 'DATA NOT UPDATE', placement: 'bottomRight' });
    }
  };
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Account Settings',
      },
      {
        name: 'Store Information',
      },
    ],
  };

  // key update method
  const handleUpdateKey = async (keyType) => {
    try {
      setIsUpdateKey({ type: keyType, loading: true });
      const res = await http.put(`/stores/${keyType}/keys/${data?._id}`);
      if (keyType === 'hmac') {
        queryClient.setQueryData('storeKeys', (prevData) => ({
          ...prevData,
          hmac_sc_api: res?.data?.data?.hmac_sc_api,
          hmac_sc_webhook: res?.data?.data?.hmac_sc_webhook,
        }));
      } else {
        queryClient.setQueryData('storeKeys', res?.data?.data);
      }
      notification.success({ message: 'KEYS UPDATED SUCCESSFULLY', placement: 'bottomRight' });
    } catch (err) {
      console.log(err);
      notification.error({ message: err?.response?.data?.message || 'KEYS NOT UPDATE!!', placement: 'bottomRight' });
    }
    setIsUpdateKey({ type: '', loading: false });
    setApiKeyModalOpen(false);
    setHmacModalOpen(false);
  };
  const forceDeleteKeys = async () => {
    try {
      setDeleteGateway(true);
      await http.delete(`/stores/api/keys/${data?._id}`);
      queryClient.setQueryData('storeKeys', (prevData) => ({
        ...prevData,
        old_keys_exits: false,
      }));
      notification.success({ message: 'OLD KEYS DELETED SUCCESSFULLY', placement: 'bottomRight' });
    } catch (err) {
      console.log(err);
      notification.error({ message: err?.response?.data?.message || 'KEYS NOT DELETED!!', placement: 'bottomRight' });
    }
    setDeleteGateway(false);
    setDelkeysModalOpen(false);
  };

  // Performance Alerts state — values mirror the backend schema exactly:
  // window_time: number (minutes), success_rate_threshold: number (integer %)
  const [paEmails, setPaEmails] = useState([]);
  const [paEmailInput, setPaEmailInput] = useState('');
  const [paEmailError, setPaEmailError] = useState('');
  const [paAlerts, setPaAlerts] = useState([]);
  const [paAlertForm, setPaAlertForm] = useState({ gateway: null, window_time: null, success_rate_threshold: null });
  const [paEditingIndex, setPaEditingIndex] = useState(null);
  const [paIsChanged, setPaIsChanged] = useState(false);
  const [paIsSaving, setPaIsSaving] = useState(false);

  const { data: gatewaysData, refetch: refetchGatewaysData } = useQuery(`allGateways_${store?._id}`, () => getGateways(store?._id), {
    enabled: false,
    manual: true,
  });

  // Seed PA state only when the active store changes (not on every data refresh)
  useEffect(() => {
    if (data?._id) {
      refetchGatewaysData();
      setPaEmails(data?.alert_emails ?? []);
      setPaAlerts(data?.performance_alerts ?? []);
      setPaAlertForm({ gateway: null, window_time: null, success_rate_threshold: null });
      setPaEditingIndex(null);
      setPaIsChanged(false);
    }
  }, [data?._id]);

  const paTimeThresholdOptions = [
    { label: '5 Minutes', value: 5 },
    { label: '15 Minutes', value: 15 },
    { label: '30 Minutes', value: 30 },
    { label: '1 Hour', value: 60 },
    { label: '3 Hours', value: 180 },
    { label: '6 Hours', value: 360 },
    { label: '12 Hours', value: 720 },
    { label: '24 Hours', value: 1440 },
  ];

  const paSuccessThresholdOptions = [10, 20, 30, 40, 50, 60, 70, 80, 90].map((n) => ({ label: `${n}%`, value: n }));

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleAddEmail = () => {
    const email = paEmailInput.trim();
    if (!email) {
      setPaEmailError('Email address is required');
      return;
    }
    if (!isValidEmail(email)) {
      setPaEmailError('Please enter a valid email address');
      return;
    }
    if (paEmails.includes(email)) {
      setPaEmailError('This email address has already been added');
      return;
    }
    setPaEmails((prev) => [...prev, email]);
    setPaEmailInput('');
    setPaEmailError('');
    setPaIsChanged(true);
  };

  const handleRemoveEmail = (email) => {
    setPaEmails((prev) => prev.filter((e) => e !== email));
    setPaIsChanged(true);
  };

  const handleAddAlert = () => {
    if (!paAlertForm.gateway || paAlertForm.window_time === null || paAlertForm.success_rate_threshold === null) {
      notification.error({ message: 'Please fill all alert configuration fields', placement: 'bottomRight' });
      return;
    }
    const isDuplicate = paAlerts.some((a, i) => a.gateway === paAlertForm.gateway && i !== paEditingIndex);
    if (isDuplicate) {
      notification.error({ message: 'An alert for this payment gateway already exists', placement: 'bottomRight' });
      return;
    }
    if (paEditingIndex !== null) {
      setPaAlerts((prev) => prev.map((a, i) => (i === paEditingIndex ? { ...paAlertForm } : a)));
      setPaEditingIndex(null);
    } else {
      setPaAlerts((prev) => [...prev, { ...paAlertForm }]);
    }
    setPaAlertForm({ gateway: null, window_time: null, success_rate_threshold: null });
    setPaIsChanged(true);
  };

  const handleEditAlert = (index) => {
    setPaAlertForm({ ...paAlerts[index] });
    setPaEditingIndex(index);
  };

  const handleDeleteAlert = (index) => {
    setPaAlerts((prev) => prev.filter((_, i) => i !== index));
    if (paEditingIndex === index) {
      setPaEditingIndex(null);
      setPaAlertForm({ gateway: null, window_time: null, success_rate_threshold: null });
    }
    setPaIsChanged(true);
  };

  const handleSaveAlerts = async () => {
    if (!paEmails.length) {
      notification.error({ message: 'Please add at least one email address', placement: 'bottomRight' });
      return;
    }
    try {
      setPaIsSaving(true);
      const payload = {
        alert_emails: paEmails,
        performance_alerts: paAlerts.map(({ gateway, window_time, success_rate_threshold }) => ({
          gateway,
          window_time,
          success_rate_threshold,
        })),
      };
      const res = await http.put(`/stores/${data?._id}`, payload);
      handleUpdateStoreData(res?.data?.data ?? {});
      notification.success({ message: 'Performance alerts saved successfully', placement: 'bottomRight' });
      setPaIsChanged(false);
    } catch (err) {
      notification.error({ message: err?.response?.data?.message || 'Failed to save performance alerts', placement: 'bottomRight' });
    } finally {
      setPaIsSaving(false);
    }
  };

  const onTabChange = (e) => {
    setActiveTab(e);
  };
  return (
    <>
      <div style={{ padding: '0px', width: '100%' }}>
        <div className='header-container'>
          <Breadcrumbs {...breadcrumbProps} />
          <div className='headerPage'>
            <div className='mb-0'>
              <PageHeader
                label={'Store Information'}
                button={<ResetButton onClick={isFetchingKeys || isFetching ? '' : activeTab === '2' ? refetchStoreKeys : refetch} loading={isFetchingKeys || isFetching} />}
              />
            </div>
            <div className='flex mr-1'>
              {data && checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                <>
                  {activeTab === '1' && (
                    <Button className='button-theme rounded-lg w-[181px]' onClick={handleEditDetails}>
                      Edit Store Setting
                    </Button>
                  )}
                  {activeTab === '3' && data?.ecommerceChannel?.type === 'shopify' && (
                    <Button className='primaryBtn mr-4' onClick={() => setEditEcomerceChannel(true)}>
                      Edit
                    </Button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className='store-info-container'>
          <Tabs defaultActiveKey='1' onTabClick={onTabChange} style={{ width: '100%' }}>
            <TabPane key='1' tab={<span id='icon'>Store Details</span>}>
              <div className='bg-white shadow rounded-lg' style={{ width: '100%' }}>
                {isLoading ? (
                  <div style={{ width: '100%' }}>
                    <Skeleton.Input style={{ width: '100%', height: '860px' }} active={true} />
                  </div>
                ) : (
                  data && (
                    <>
                      {window.innerWidth < 641 ? (
                        <div className='bg-[#FAFAFA] h-[54px] rounded-border p-[3.53%] pt-[5%] font-semibold'>Title & Detail</div>
                      ) : (
                        <>
                          <div className='flex bg-[#FAFAFA] h-[54px] rounded-border'>
                            <div className='m-[1%] pl-[1%] pt-[0.75%] font-semibold text-[#262626]'>Title</div>
                            <div className='m-[1%] ml-[29.7%] pt-[0.75%] font-semibold text-[#262626]'>Details</div>
                          </div>
                        </>
                      )}

                      {storeData?.map((obj, index) => (
                        <>
                          <div className='px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6' key={index}>
                            <dt className='text-sm font-medium text-[#262626]'>{obj?.title}</dt>
                            <dd className='mt-1 text-sm text-[#262626] sm:mt-0 sm:col-span-2 overflow-hidden'>{obj?.value}</dd>
                          </div>
                          <Divider style={{ marginTop: '-0px', marginBottom: '-0px', backgroundColor: '#F5F5F5' }} />
                        </>
                      ))}
                    </>
                  )
                )}
              </div>
            </TabPane>
            {data && (
              <TabPane tab={<span id='icon'>Keys Details</span>} key='2'>
                <div className='rounded-border' style={{ width: '100%' }}>
                  {isLoadingStoreKeys ? (
                    <div style={{ width: '100%' }}>
                      <Skeleton.Input style={{ width: '100%', height: '860px' }} active={true} />
                    </div>
                  ) : !storeKeys ? (
                    <div className='bg-white rounded-lg'>
                      <Empty image={<EmptyIcon />} style={{ padding: '50px' }} description={'Generate keys to integrate fusion API flow.'}>
                        {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                          <Button className='primaryBtn' onClick={generateFirstTimeKeys}>
                            Generate Keys{' '}
                          </Button>
                        )}
                      </Empty>
                    </div>
                  ) : (
                    <>
                      {window.innerWidth < 641 ? (
                        <div className='bg-[#FAFAFA] h-[54px] rounded-border p-[3.53%] pt-[5%] font-semibold'>Title & Detail</div>
                      ) : (
                        <>
                          <div className='flex bg-[#FAFAFA] h-[54px] rounded-border'>
                            <div className='m-[1%] pl-[1%] pt-[0.75%] font-semibold text-[#262626]'>Title</div>
                            <div className='m-[1%] ml-[28.3%] pt-[0.75%] font-semibold text-[#262626]'>Details</div>
                          </div>
                        </>
                      )}
                      <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                        <dt className='text-sm font-medium text-[#262626]'>Webhook URL</dt>
                        <dd className='mt-1 text-sm text-[#262626] sm:mt-0 sm:col-span-2 overflow-hidden'>
                          {isUpdateWebhook ? (
                            <div className='webhookPanel'>
                              <Input defaultValue={data?.webhookURL} onChange={(e) => setWebhookUrl(e.target.value)} placeholder='Enter webhook url' name='webhook' />
                              <ANTButton className='removeIcon MobileView rounded-lg' onClick={() => handleEditWebhookDetails('cancel')}>
                                Cancel
                              </ANTButton>
                              <Button className='updateIcon' style={{ color: '#fff' }} onClick={handleEditDetailsData} disabled={webhookUrl ? false : true}>
                                Update
                              </Button>
                            </div>
                          ) : (
                            <div className='webhookBtn bg-white'>
                              {data?.webhookURL ?? 'Not Provided'}
                              {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_DEVELOPER, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                                <>
                                  {data?.webhookURL && (
                                    <ANTButton
                                      className='remove-btn'
                                      onClick={() => {
                                        setUrlModalOpen(true);
                                      }}>
                                      Delete
                                    </ANTButton>
                                  )}
                                  <ANTButton className='editIcon' onClick={() => handleEditWebhookDetails('')}>
                                    {data?.webhookURL ? 'Edit' : 'Add'}
                                  </ANTButton>
                                </>
                              )}
                            </div>
                          )}
                        </dd>
                      </div>
                      <Divider style={{ marginTop: '0px', marginBottom: '0px', backgroundColor: '#F5F5F5' }} />
                      {storeKeys?.api_keys && (
                        <>
                          <div className='px-4 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-[#262626]'>Key Creation Date</dt>
                            <dd className='mt-1 text-sm text-[#262626] sm:mt-0 sm:col-span-2 overflow-hidden'>
                              {storeKeys?.api_keys?.key_created_at
                                ? formatInTimeZone(storeKeys?.api_keys?.key_created_at, data?.settings?.timezone || TIMEZONES.PKT, 'MMM d, yyyy h:mm:ss a')
                                : 'Not Set'}
                            </dd>
                          </div>
                          <Divider style={{ marginTop: '0px', marginBottom: '0px', backgroundColor: '#F5F5F5' }} />
                          <div className='px-4 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-[#262626]'>Last Update</dt>
                            <dd className='mt-1 text-sm text-[#262626] sm:mt-0 sm:col-span-2 overflow-hidden'>
                              {storeKeys?.api_keys?.key_updated_at
                                ? formatInTimeZone(storeKeys?.api_keys?.key_updated_at, data?.settings?.timezone || TIMEZONES.PKT, 'MMM d, yyyy h:mm:ss a')
                                : 'Not Set'}
                            </dd>
                          </div>
                          <Divider style={{ marginTop: '0px', marginBottom: '0px', backgroundColor: '#F5F5F5' }} />
                          <div className='px-4 bg-white rounded-bl-2xl rounded-br-2xl py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                            <dt className='text-sm font-medium text-[#262626]'>Last Used</dt>
                            <dd className='mt-1 text-sm text-[#262626] sm:mt-0 sm:col-span-2 overflow-hidden'>
                              {storeKeys?.api_keys?.key_last_used_at
                                ? formatInTimeZone(storeKeys?.api_keys?.key_last_used_at, data?.settings?.timezone || TIMEZONES.PKT, 'MMM d, yyyy h:mm:ss a')
                                : 'Not Set'}
                            </dd>
                          </div>
                        </>
                      )}

                      <div className='bg-white rounded-tl-2xl rounded-tr-2xl px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 mt-4'>
                        <dt className='text-sm text-black keysPanel' style={{ fontSize: '17px', fontWeight: '600' }}>
                          <div className='resetBtnKeys'>
                            Api Keys
                            {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_DEVELOPER, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                              // <Popconfirm
                              //   title='Are you sure to generate new Keys?'
                              //   onConfirm={() => handleUpdateKey('api')}
                              //   okText='Yes'
                              //   cancelText='No'
                              //   getPopupContainer={(trigger) => trigger.parentNode}>
                              <span style={{ marginLeft: '7px', fontSize: '10px' }}>
                                {
                                  <ResetButton
                                    onClick={() => {
                                      setApiKeyModalOpen(true);
                                    }}
                                    loading={isUpdateKey.type == 'api' ? isUpdateKey.loading : false}
                                  />
                                }
                              </span>
                              // </Popconfirm>
                            )}
                          </div>
                          {storeKeys?.old_keys_exits && checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_DEVELOPER]) && (
                            <div className='oldKeysBtn' style={{ cursor: 'pointer' }}>
                              {/* <Popconfirm title='Are you sure to delete old Keys?' onConfirm={forceDeleteKeys} okText='Yes' cancelText='No' getPopupContainer={(trigger) => trigger.parentNode}> */}
                              {/* <Button>Delete Old Keys</Button> */}
                              <div
                                onClick={() => {
                                  setDelkeysModalOpen(true);
                                }}>
                                <Tooltip title={'Delete old keys'}>
                                  <DeleteIconFilled />
                                </Tooltip>
                              </div>
                              {/* </Popconfirm> */}
                            </div>
                          )}
                        </dt>
                      </div>
                      {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_DEVELOPER]) && (
                        <div className='flex'>
                          {(storeKeys?.api_keys?.publicKey || storeKeys?.api_keys?.secreteKey) && (
                            <div className='p-3 bg-white' style={{ width: '100%' }}>
                              <div className='bg-[#FFFBE6] gap-3 p-3 rounded-lg flex border border-[#FFE58F]'>
                                <div className='mt-[2px]'>
                                  <CautionIcon />
                                </div>
                                <div>Save the public and private keys as they will not be displayed again. If you lose keys, new keys will be generated.</div>
                              </div>
                            </div>
                          )}
                          {storeKeys?.old_keys_exits && (
                            <div className='p-3 bg-white' style={{ width: '100%' }}>
                              <div className='bg-[#E6F7FF] gap-3 p-3 rounded-lg flex border border-[#91D5FF]'>
                                <div className='mt-[2px]'>
                                  <InfoIcon />
                                </div>
                                <div>If you want to delete your old keys now, force delete them with the delete icon above. Otherwise, it will be automatically deleted after 24 hours</div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {storeKeys?.api_keys ? (
                        <>
                          <div className='bg-white px-4 py-4 block'>
                            <dt className='text-sm font-medium text-[#262626] mb-2'>Public Key</dt>
                            <dd className='mt-1 h-[40px] p-3 border sm:mt-0 sm:col-span-2 overflow-hidden mobileWidthchamge rounded-lg text-sm text-gray-900'>
                              {storeKeys?.api_keys?.publicKey
                                ? storeKeys?.api_keys?.publicKey
                                : [...Array(49)].map((e, i) => (
                                    <span className='text-sm' key={i}>
                                      &#x002A;
                                    </span>
                                  ))}
                            </dd>
                          </div>
                          <div className='bg-white px-4 py-4 block rounded-bl-2xl rounded-br-2xl'>
                            <dt className='text-sm font-medium text-[#262626] mb-2'>Secret Key</dt>
                            <dd className={`mt-1 text-sm p-2 text-gray-900 border rounded-lg break-words` + (window.innerWidth < 768 ? ' h-[60px]' : ' h-[40x]')}>
                              {storeKeys?.api_keys?.secreteKey
                                ? storeKeys?.api_keys?.secreteKey
                                : [...Array(49)].map((e, i) => (
                                    <span className='text-sm' key={i}>
                                      &#x002A;
                                    </span>
                                  ))}
                            </dd>
                          </div>
                        </>
                      ) : (
                        <div className='bg-white px-5 sm:px-6'>
                          <p>Please generate new api keys.</p>
                        </div>
                      )}
                      <div className='bg-white rounded-tl-2xl rounded-tr-2xl px-4 py-3 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6 mt-3'>
                        <dt className='text-sm resetBtnKeys' style={{ fontSize: '17px', fontWeight: '600' }}>
                          Signature Secrets
                          {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_DEVELOPER]) && (
                            // <Popconfirm
                            //   title='Are you sure to generate new HMAC Keys?'
                            //   onConfirm={() => handleUpdateKey('hmac')}
                            //   okText='Yes'
                            //   cancelText='No'
                            //   getPopupContainer={(trigger) => trigger.parentNode}>
                            <span style={{ marginLeft: '7px', fontSize: '10px' }}>
                              {
                                <ResetButton
                                  onClick={() => {
                                    setHmacModalOpen(true);
                                  }}
                                  loading={isUpdateKey.type == 'hmac' ? isUpdateKey.loading : false}
                                />
                              }
                            </span>
                            // </Popconfirm>
                          )}
                        </dt>
                      </div>
                      <div className='bg-white px-4 py-4 block'>
                        <dt className='text-sm font-medium text-[#262626] mb-4'>API Signature Secret</dt>
                        <dd className={`mt-1 text-sm p-2 text-gray-900 border rounded-lg break-words` + (window.innerWidth < 768 ? ' h-[60px]' : ' h-[40x]')}>
                          {storeKeys?.hmac_sc_api ? storeKeys?.hmac_sc_api : 'Not Provided'}
                        </dd>
                      </div>
                      <div className='rounded-bl-2xl rounded-br-2xl bg-white px-4 py-4'>
                        <dt className='text-sm font-medium text-[#262626] w-[50%] mb-4'>Webhook Signature Secret</dt>
                        <dd className={`mt-1 text-sm p-2 text-gray-900 border rounded-lg break-words` + (window.innerWidth < 768 ? ' h-[60px]' : ' h-[40x]')}>
                          {storeKeys?.hmac_sc_webhook ? storeKeys?.hmac_sc_webhook : 'Not Provided'}
                        </dd>
                      </div>
                    </>
                  )}
                </div>
              </TabPane>
            )}
            {data && (
              <TabPane className='custom-table' tab={<span id='icon'>Shopify App Details</span>} key='3'>
                {isLoading ? (
                  <div style={{ width: '100%' }} className='bg-white rounded-lg'>
                    <Skeleton.Input style={{ width: '100%', height: '860px' }} active={true} />
                  </div>
                ) : !data?.ecommerceChannel ? (
                  <div className='bg-white rounded-lg' style={{ width: '100%' }}>
                    <Empty
                      className='rounded-rounded'
                      image={<EmptyIcon />}
                      style={{ padding: '50px' }}
                      description={
                        <>
                          <header style={{ fontSize: '14px', color: '#0A090B', fontWeight: '550' }}>Shopify Configuration</header>
                          <span style={{ color: '#4F4D55' }}>Integrate Shopify app with the XPay application.</span>
                        </>
                      }>
                      {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                        <Button className='primaryBtn' onClick={() => setEditEcomerceChannel(true)}>
                          Add Shopify App
                        </Button>
                      )}
                    </Empty>
                  </div>
                ) : data?.ecommerceChannels?.length > 0 ? (
                  data?.ecommerceChannels?.map((obj, index) => {
                    return (
                      <div className='bg-white rounded-lg mb-4' style={{ width: '100%' }} key={index}>
                        {ecommerceChannelData(obj)?.map((obj, index) => {
                          return (
                            <div className='bg-white rounded-lg px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6' key={index}>
                              <dt className='text-sm font-medium text-gray-500'>{obj?.title}</dt>
                              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 overflow-hidden'>{obj?.value}</dd>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })
                ) : (
                  <div className='bg-white rounded-lg' style={{ width: '100%' }}>
                    {ecommerceChannelData(data?.ecommerceChannel)?.map((obj, index) => {
                      return (
                        <div className='bg-white rounded-lg px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6' key={index}>
                          <dt className='text-sm font-medium text-gray-500'>{obj?.title}</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 overflow-hidden'>{obj?.value}</dd>
                        </div>
                      );
                    })}
                  </div>
                )}
                {data?.ecommerceChannel && data?.ecommerceChannels?.length > 0 && (
                  <div className='bg-white rounded-lg' style={{ width: '100%' }}>
                    <div className='bg-white rounded-lg px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                      <Form layout='vertical' onFinish={onFinish} initialValues={values}>
                        <dt className='text-sm text-black keysPanel' style={{ fontSize: '17px', fontWeight: '600' }}>
                          Custom App Credentials
                        </dt>
                        <br />
                        {/* Select Type */}
                        <Form.Item className='customSelect modal-field mobileViewSelect' label='App Flow' name='channelType' rules={[{ required: true, message: 'Please select channel type' }]}>
                          <Select placeholder='Select channel type' defaultValue={selectedType} onChange={(option) => setSelectedType(option?.value)}>
                            <Option value='legacy'>Legacy</Option>
                            <Option value='dev_dashboard'>Dev Dashboard</Option>
                          </Select>
                        </Form.Item>
                        {/* Conditional Fields */}
                        {selectedType === 'legacy' && (
                          <Form.Item label='Access Token' name='accessToken' rules={[{ required: true, message: 'Access Token is required' }]}>
                            <Input placeholder='Enter Access Token' type='password' />
                          </Form.Item>
                        )}
                        {selectedType === 'dev_dashboard' && (
                          <>
                            <Form.Item label='Client ID' name='clientId' rules={[{ required: true, message: 'Client ID is required' }]}>
                              <Input placeholder='Enter Client ID' name='client_id' />
                            </Form.Item>

                            <Form.Item label='Client Secret' name='clientSecret' rules={[{ required: true, message: 'Client Secret is required' }]}>
                              <Input placeholder='Enter Client Secret' name='client_secret' type='password' />
                            </Form.Item>
                          </>
                        )}
                        <Form.Item>
                          <Button block type='primary' className='primaryBtn ml-4' htmlType='submit'>
                            Submit
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                )}
              </TabPane>
            )}
            {data && (
              <TabPane key='4' tab={<span id='icon'>Performance Alerts</span>}>
                <div style={{ width: '100%' }}>
                  {/* Email Address Configuration */}
                  <div className='bg-white shadow rounded-lg p-6 mb-4'>
                    <h3 className='text-base font-semibold text-[#262626] mb-1'>Email Address Configuration</h3>
                    <p className='text-sm text-[#8C8C8C] mb-4'>Add email addresses that will receive performance alert notifications</p>
                    <div className='flex gap-2 mb-1' style={{ flexWrap: 'wrap' }}>
                      <Input
                        value={paEmailInput}
                        onChange={(e) => {
                          setPaEmailInput(e.target.value);
                          if (paEmailError) setPaEmailError('');
                        }}
                        onPressEnter={handleAddEmail}
                        placeholder='Enter email address'
                        style={{ maxWidth: '360px', flex: '1 1 200px' }}
                      />
                      <Button className='custom-btns p-2 flex items-center' onClick={handleAddEmail}>
                        Add Email
                      </Button>
                    </div>
                    {paEmailError && <div style={{ color: '#E12121', fontSize: '12px', marginBottom: '8px' }}>{paEmailError}</div>}
                    {paEmails.length > 0 && (
                      <div className='flex flex-wrap gap-2 mt-3'>
                        {paEmails.map((email) => (
                          <Tag
                            key={email}
                            closable
                            onClose={(e) => {
                              e.preventDefault();
                              handleRemoveEmail(email);
                            }}
                            style={{ background: '#F0F5FF', border: '1px solid #ADC6FF', color: '#2F54EB', borderRadius: '20px', padding: '2px 10px', fontSize: '13px' }}>
                            {email}
                          </Tag>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Alert Configuration */}
                  <div className='bg-white shadow rounded-lg p-6 mb-4'>
                    <h3 className='text-base font-semibold text-[#262626] mb-1'>Alert Configuration</h3>
                    <p className='text-sm text-[#8C8C8C] mb-4'>{paEditingIndex !== null ? 'Update the selected alert' : 'Configure a new performance alert'}</p>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
                      <div>
                        <div className='text-sm font-medium text-[#262626] mb-1'>
                          Payment Gateway <span style={{ color: '#E12121' }}>*</span>
                        </div>
                        <ANTDSelect
                          value={paAlertForm.gateway}
                          onChange={(val) => setPaAlertForm((prev) => ({ ...prev, gateway: val }))}
                          placeholder='Select payment gateway'
                          style={{ width: '100%' }}
                          listHeight={160}
                          popupClassName='pa-scrollable-dropdown'
                          getPopupContainer={(trigger) => trigger.parentNode}>
                          {(gatewaysData || []).map((gw) => (
                            <ANTDSelect.Option key={gw._id} value={gw.gateway_type}>
                              {gw.name}
                            </ANTDSelect.Option>
                          ))}
                        </ANTDSelect>
                      </div>
                      <div>
                        <div className='text-sm font-medium text-[#262626] mb-1'>
                          Time Threshold <span style={{ color: '#E12121' }}>*</span>
                        </div>
                        <ANTDSelect
                          value={paAlertForm.window_time}
                          onChange={(val) => setPaAlertForm((prev) => ({ ...prev, window_time: val }))}
                          placeholder='Select time threshold'
                          style={{ width: '100%' }}
                          listHeight={160}
                          popupClassName='pa-scrollable-dropdown'
                          getPopupContainer={(trigger) => trigger.parentNode}>
                          {paTimeThresholdOptions.map((opt) => (
                            <ANTDSelect.Option key={opt.value} value={opt.value}>
                              {opt.label}
                            </ANTDSelect.Option>
                          ))}
                        </ANTDSelect>
                      </div>
                      <div>
                        <div className='text-sm font-medium text-[#262626] mb-1'>
                          Performance Success Threshold <span style={{ color: '#E12121' }}>*</span>
                        </div>
                        <ANTDSelect
                          value={paAlertForm.success_rate_threshold}
                          onChange={(val) => setPaAlertForm((prev) => ({ ...prev, success_rate_threshold: val }))}
                          placeholder='Select success threshold'
                          style={{ width: '100%' }}
                          listHeight={160}
                          popupClassName='pa-scrollable-dropdown'
                          getPopupContainer={(trigger) => trigger.parentNode}>
                          {paSuccessThresholdOptions.map((opt) => (
                            <ANTDSelect.Option key={opt.value} value={opt.value}>
                              {opt.label}
                            </ANTDSelect.Option>
                          ))}
                        </ANTDSelect>
                      </div>
                    </div>
                    <div className='flex gap-2'>
                      <Button className='custom-btns p-2 flex items-center' onClick={handleAddAlert}>
                        {paEditingIndex !== null ? 'Update Alert' : 'Add Alert'}
                      </Button>
                      {paEditingIndex !== null && (
                        <ANTButton
                          className='rounded-lg'
                          onClick={() => {
                            setPaEditingIndex(null);
                            setPaAlertForm({ gateway: null, timeThreshold: null, successThreshold: null });
                          }}>
                          Cancel
                        </ANTButton>
                      )}
                    </div>
                  </div>

                  {/* Alerts Listing */}
                  {paAlerts.length > 0 && (
                    <div className='bg-white shadow rounded-lg p-6 mb-4'>
                      <h3 className='text-base font-semibold text-[#262626] mb-4'>Configured Alerts</h3>
                      <ANTDTable
                        dataSource={paAlerts.map((a, i) => ({ ...a, key: i }))}
                        pagination={false}
                        rowClassName={(_, index) => (index === paEditingIndex ? 'ant-table-row-selected' : '')}
                        columns={[
                          {
                            title: 'Payment Gateway',
                            dataIndex: 'gateway',
                            render: (val) => {
                              const gw = (gatewaysData || []).find((g) => g.gateway_type === val);
                              return gw?.name || val || '-';
                            },
                          },
                          {
                            title: 'Time Threshold',
                            dataIndex: 'window_time',
                            render: (val) => paTimeThresholdOptions.find((o) => o.value === val)?.label ?? val ?? '-',
                          },
                          {
                            title: 'Performance Success Threshold',
                            dataIndex: 'success_rate_threshold',
                            render: (val) => paSuccessThresholdOptions.find((o) => o.value === val)?.label ?? val ?? '-',
                          },
                          {
                            title: 'Actions',
                            render: (_, __, index) => (
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <div
                                  className='table-action-btn'
                                  style={{ width: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', cursor: 'pointer' }}
                                  onClick={() => handleEditAlert(index)}>
                                  Edit
                                </div>
                                <div
                                  className='table-action-btn'
                                  style={{ color: '#E12121', border: '1px solid #E12121', fontSize: '14px', cursor: 'pointer' }}
                                  onClick={() => handleDeleteAlert(index)}>
                                  Delete
                                </div>
                              </div>
                            ),
                          },
                        ]}
                      />
                    </div>
                  )}

                  {/* Save */}
                  <Tooltip title={!paIsChanged ? 'No changes to save' : ''}>
                    <span style={{ display: 'block', marginTop: '16px' }}>
                      <Button className='button-theme rounded-lg w-[120px]' disabled={!paIsChanged} loading={paIsSaving} onClick={handleSaveAlerts}>
                        Save
                      </Button>
                    </span>
                  </Tooltip>
                </div>
              </TabPane>
            )}
          </Tabs>
        </div>
      </div>
      <Modal open={open} width={window.innerWidth < 768 ? 320 : 400} onCancel={handleEditDetails} destroyOnClose footer={null}>
        <div className='exportModal'>
          <header className='font-semibold text-base mb-4'>Edit Store Setting</header>
          <EditStore handleOpen={handleEditDetails} updateState={handleUpdateStoreData} store={data} />
        </div>
      </Modal>
      <Modal
        open={urlModalOpen}
        width={400}
        footer={null}
        onCancel={() => {
          setUrlModalOpen(false);
        }}>
        <div className='h-[130px]'>
          <header className='font-semibold text-base'>Delete Webhook URL</header>
          Are you sure you want to delete the webhook URL?
          <div className='flex mt-8'>
            <Button
              className='mr-4 rounded-lg bg-plain'
              block
              onClick={() => {
                setUrlModalOpen(false);
              }}>
              Cancel
            </Button>
            <Button block className='rounded-lg DeleteBtn' onClick={removeWebhook}>
              CONFIRM
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={delkeysModalOpen}
        width={400}
        footer={null}
        onCancel={() => {
          setDelkeysModalOpen(false);
        }}>
        <>
          <header className='font-semibold text-base'>Delete Old Keys</header>
          Are you sure you want to delete Old Keys?
          <div className='flex mt-4'>
            <Button
              className='mr-4 rounded-lg bg-plain'
              block
              onClick={() => {
                setDelkeysModalOpen(false);
              }}>
              Cancel
            </Button>
            <Button block className='rounded-lg DeleteBtn' onClick={forceDeleteKeys}>
              CONFIRM
            </Button>
          </div>
        </>
      </Modal>
      <Modal
        open={apiKeyModalOpen}
        width={400}
        footer={null}
        onCancel={() => {
          setApiKeyModalOpen(false);
        }}>
        <header className='font-semibold text-base mb-4'>Generate API Keys</header>
        Are you sure you want to generate new API Keys?
        <div className='flex mt-9'>
          <Button
            className='mr-4 rounded-lg bg-plain'
            block
            onClick={() => {
              setApiKeyModalOpen(false);
            }}>
            Cancel
          </Button>
          <Button block className='button-theme rounded-lg' onClick={() => handleUpdateKey('api')}>
            YES
          </Button>
        </div>
      </Modal>
      <Modal
        open={hmacModalOpen}
        width={400}
        footer={null}
        onCancel={() => {
          setHmacModalOpen(false);
        }}>
        <header className='font-semibold text-base mb-4'>Generate HMAC Keys</header>
        Are you sure you want to generate new HMAC Keys?
        <div className='flex mt-9'>
          <Button
            className='mr-4 rounded-lg bg-plain'
            block
            onClick={() => {
              setHmacModalOpen(false);
            }}>
            Cancel
          </Button>
          <Button block className='button-theme rounded-lg' onClick={() => handleUpdateKey('hmac')}>
            YES
          </Button>
        </div>
      </Modal>
      <Modal
        open={editEcomerceChannel}
        footer={null}
        destroyOnClose
        className='exportModalContainer'
        width={400}
        onCancel={() => {
          setEditEcomerceChannel(!editEcomerceChannel);
        }}>
        <header className='font-semibold text-base mb-4'>App Configuration</header>
        <AppOnboarding handleOpen={setEditEcomerceChannel} handleUpdate={handleUpdateStoreData} store={data} />
      </Modal>
    </>
  );
};
